import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { addClubRoute } from './clubs/add.route';
import { clubRoute } from './clubs/club.route';
import { clubsRoute } from './clubs/clubs.route';

export const clubContainerRoute: RouteConfig = {
  path: '/clubs',
  component: RouterView,
  children: [clubsRoute, addClubRoute, clubRoute],
  meta: {
    authorized: true,
    breadcrumb: {
      title: 'breadcrumbs.clubs.list',
      name: 'clubs'
    },
    menu: {
      title: 'menu.clubs',
      icon: 'fa-flag',
      permissions: ['CLUB.LIST'],
      name: 'clubs'
    }
  },
  redirect: { name: 'clubs' }
};
